// <fp-package-picker> (sections/fp-purchase-card.liquid): picking a package pill shows that variant's price,
// points every [data-fp-create-link] at /products/{handle}?view=create&package={variant id}, updates the mobile
// sticky bar, and mirrors the choice in ?variant= so a reload or shared link keeps it.

class FpPackagePicker extends HTMLElement {
  connectedCallback() {
    this.base = this.dataset.createBase;
    this.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"]')) this.select(event.target);
    });
  }

  select(input) {
    const id = input.value;

    for (const price of this.querySelectorAll('[data-fp-variant-price]')) {
      price.hidden = price.dataset.fpVariantPrice !== id;
    }
    for (const link of this.querySelectorAll('[data-fp-create-link]')) {
      // Keep a look picked in <fp-look-picker> (?look=) when the package changes.
      const look = new URL(link.getAttribute('href'), location.origin).searchParams.get('look');
      link.href = this.base + id + (look ? `&look=${encodeURIComponent(look)}` : '');
    }

    const pkg = this.querySelector('[data-fp-sticky-package]');
    if (pkg) pkg.textContent = input.dataset.title;
    const price = this.querySelector('[data-fp-sticky-price]');
    if (price) price.textContent = input.dataset.price;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', id);
    history.replaceState(history.state, '', url);
  }
}

if (!customElements.get('fp-package-picker')) customElements.define('fp-package-picker', FpPackagePicker);
